const BASE_URL = import.meta.env.BASE_URL;

const ASSETS = {
  CUSTOMER_LOGO: `${BASE_URL}/assets/images/LOYALTY_IMG_CUSTOMER_LOGO.png`,
  SIGNUP_BANNER: `${BASE_URL}/assets/images/LOYALTY_IMG_SIGNUP_BANNER.png`,
  PROGRAMME_LOGO: `${BASE_URL}/assets/images/LOYALTY_IMG_PROGRAMME_LOGO.png`,
  REWARDS: `${BASE_URL}/assets/images/LOYALTY_IMG_CROWN.png`,
  REWARD_CONFIG: `${BASE_URL}/assets/images/LOYALTY_IMG_REWARD_PLACEHOLDER.png`,
  TIER_BENEFITS: `${BASE_URL}/assets/images/LOYALTY_IMG_TIERS_GRAPH.png`,
  LANDING_PAGE_LOGO: `${BASE_URL}/assets/images/LOYALTY_IMG_LANDING_PAGE_LOGO.png`,
  LANDING_PAGE_JOIN: `${BASE_URL}/assets/images/LOYALTY_IMG_LANDING_PAGE_JOIN.svg`,
  LANDING_PAGE_EARN: `${BASE_URL}/assets/images/LOYALTY_IMG_LANDING_PAGE_EARN.svg`,
  LANDING_PAGE_REDEEM: `${BASE_URL}/assets/images/LOYALTY_IMG_LANDING_PAGE_REDEEM.svg`,
  TIER_IMAGE: `${BASE_URL}/assets/images/LOYALTY_IMG_TROPHY.png`,
  REWARD_IMAGE: `${BASE_URL}/assets/images/LOYALTY_IMG_REWARD_PLACEHOLDER.png`,
};

export { ASSETS };
